export { default as MemberOrNoviceSelection } from './MemberOrNoviceSelection';
export { default as MemberForm } from './MemberForm';
export { default as NoviceForm } from './NoviceForm';
export { default as Registration } from './Registration';

// Ajouter un export par défaut
export { default } from './Registration';